import React from 'react'

import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'

import { WidgetComponent } from '../../types/widgets.types'
import { WidgetWrapper } from '../WidgetWrapper'

export const BudgetWidget: WidgetComponent = ({ ...widgetProps }) => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_EMPLOYEES_APP_DEV_PATH,
    'hr',
    './BonusWidget',
    'employeesApp'
  )

  // @ts-expect-error: dynamic import
  const { ExposedBonusWidget: HrBudgetWidget } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : { ExposedBonusWidget: () => <></> }

  return (
    <WidgetWrapper {...widgetProps} isLoading={!isLoaded}>
      <HrBudgetWidget />
    </WidgetWrapper>
  )
}
